import React from "react";
// import "./admin.css";
import { useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
export default () => {
  const {
    newMailValid,
    currentUser,
    currentUserIsAdmin,
    currentUserIsLawyer,
    currentUserIsCustomer,
    currentUserIsActive,
    allUsers,
  } = useSelector((state) => state.mainReducer);
  return (
    <>
      <div className="divwala">
        <div className="sidebarr">
          <a
            style={{ textTransformation: "uppercase !important" }}
            className="active"
            href="#home"
          >
            {currentUser.actorRole} PANEL
          </a>
          <Link to={"/admin/lawyerRequest"}>Lawyer</Link>
        </div>
        <div>
          <div>
            <div className="contentt">{true ? <Outlet /> : null}</div>
          </div>
        </div>
      </div>
    </>
  );
};
